import { useState, useRef } from 'react';

import { Box, TextField, Menu, MenuItem, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function UrlInput({ maxLength, placeholder = '', protocol = 'http', onChangeProtocol, inputValue, onChangeInputValue, disabled = false, error = false }) {
  const theme = useTheme();
  const textRef = useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  return (
    <Box
      sx={{
        display: 'flex',
        border: `${error ? '1px solid #d32f2f' : '1px solid rgb(146, 146, 146)'}`,
        borderRadius: '8px',
        overflow: 'hidden',
        width: '300px',
        height: '30px',
        '&:hover': {
          borderColor: theme.palette.primary.mainHover,
        },
      }}
    >
      <Box
        ref={textRef}
        onClick={() => setAnchorEl(textRef.current)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: 1.5,
          fontWeight: 500,
          cursor: 'pointer',
          userSelect: 'none',
          pointerEvents: disabled ? 'none' : 'auto',
          color: disabled ? 'rgba(0, 0, 0, 0.38)' : theme.palette.primary.main,
        }}
      >
        {protocol === 'https' ? 'https://' : 'http://'}
      </Box>

      <IconButton
        onClick={() => setAnchorEl(textRef.current)}
        disableRipple
        sx={{
          background: theme.palette.primary.main,
          borderRadius: 0,
          width: 32,
          cursor: 'pointer',
          transition: '0.2s',
          '& svg': {
            color: '#fff',
            transition: '0.2s',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          },
          '&:hover': {
            background: theme.palette.primary.mainHover,
          },
          pointerEvents: disabled ? 'none' : 'auto',
        }}
      >
        <ExpandMoreIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{ dense: true }}
        sx={{
          boxShadow: '0px 1px 4px rgba(0,0,0,0.08)',
          borderRadius: '8px',
          mt: '2px',
        }}
      >
        <MenuItem
          selected={protocol === 'http'}
          onClick={() => {
            onChangeProtocol('http');
            setAnchorEl(null);
          }}
          sx={{
            borderRadius: '8px',
            color: '#172664',
            margin: '2px 8px 0px 8px',
            '&.Mui-selected': {
              backgroundColor: theme.palette.primary.subBlue,
            },
            '&.Mui-selected:hover': {
              backgroundColor: theme.palette.primary.subBlue,
            },
          }}
        >
          http://
        </MenuItem>

        <MenuItem
          selected={protocol === 'https'}
          onClick={() => {
            onChangeProtocol('https');
            setAnchorEl(null);
          }}
          sx={{
            borderRadius: '8px',
            color: '#172664',
            margin: '2px 8px 0px 8px',
            '&.Mui-selected': {
              backgroundColor: theme.palette.primary.subBlue,
            },
            '&.Mui-selected:hover': {
              backgroundColor: theme.palette.primary.subBlue,
            },
          }}
        >
          https://
        </MenuItem>
      </Menu>

      <TextField
        fullWidth
        variant="outlined"
        sx={{
          '& fieldset': { border: 'none' },
          '& .MuiOutlinedInput-root': {
            paddingBottom: '3px',
            height: 30,
          },
        }}
        inputProps={{
          ...(maxLength !== undefined && { maxLength }),
        }}
        placeholder={placeholder}
        autoComplete="off"
        value={inputValue || ''}
        onChange={e => onChangeInputValue(e.target.value)}
        disabled={disabled}
      />
    </Box>
  );
}
